module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av136-84117e60298458de851bf226ab980543.jpg";